import { Component, signal, computed } from '@angular/core';

type StatusLevel = 'ok' | 'warn' | 'down';

@Component({
  selector: 'app-footer',
  template: `
    <footer>
      <span class="footer-divider" aria-hidden="true"></span>

      <div class="status-row">
        <div class="status-pill" [attr.data-level]="status()" [title]="statusLabel()">
          <span class="status-dot" aria-hidden="true">
            <span class="status-dot-core"></span>
            <span class="status-dot-ring"></span>
          </span>
          <span class="status-label">{{ statusLabel() }}</span>
        </div>

        <button type="button" class="version-pill" [title]="'Build ' + buildHash()">
          <i class="dx-icon-tags" aria-hidden="true"></i>
          <span>{{ version }}</span>
        </button>
      </div>

      <div class="copyright"><ng-content></ng-content></div>
    </footer>
  `,
  styleUrls: ['./app-footer.component.scss'],
})
export class AppFooterComponent {
  readonly version = 'v1.0.0';
  readonly status = signal<StatusLevel>('ok');
  readonly buildHash = signal('a1b2c3d');
  readonly statusLabel = computed(() => {
    switch (this.status()) {
      case 'warn': return 'Servicio degradado';
      case 'down': return 'Sin conexion';
      default:     return 'Sistema operativo';
    }
  });
}
